import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { pathToRegexp } from 'path-to-regexp/dist';
import { withRouter } from 'react-router-dom';

class AppSidebarItem extends Component {
  state = {
    isOpen: false,
  };

  componentDidMount() {
    const isActive = this.props.active
      ? this.props.active(this.props.location, this.props.path)
      : pathToRegexp(this.props.path).test(this.props.location.pathname);

    this.setState({ isOpen: isActive });
  }

  go = path => {
    path ? this.props.history.push(path) : this.props.history.push(this.props.path);
  };

  render() {
    const isActive = this.props.active
      ? this.props.active(this.props.location, this.props.path)
      : pathToRegexp(this.props.path).test(this.props.location.pathname);

    const isMenuRoute = this.props.childRoutes && this.props.childRoutes.length > 0;

    return (
      <Fragment>
        <li className={classNames('sidebar-nav-link', this.props.className, { active: isActive })}>
          <a
            onClick={
              isMenuRoute ? () => this.setState({ isOpen: !this.state.isOpen }) : () => this.go()
            }
          >
            {this.props.icon}
            <div className={classNames('sidebar-label', { collapsed: this.props.collapsed })}>
              {this.props.label}
              {isMenuRoute && (
                <span style={{ position: 'relative', float: 'right', marginTop: '0' }}>
                  {this.state.isOpen ? (
                    <i className="fa fa-angle-up" style={{ fontSize: '14px', marginRight: '0' }} />
                  ) : (
                    <i
                      className="fa fa-angle-down"
                      style={{ fontSize: '14px', marginRight: '0' }}
                    />
                  )}
                </span>
              )}
            </div>
          </a>
          {this.props.badge && this.props.badge(this.props)}
        </li>
        {this.state.isOpen &&
          this.props.childRoutes &&
          this.props.childRoutes.map(el => (
            <li
              className={classNames('sidebar-nav-link', this.props.className, {
                active: el.active(this.props.location),
              })}
              style={{ paddingLeft: '35px' }}
            >
              <a onClick={() => this.go(el.path)}>
                {el.icon}
                <div className={classNames('sidebar-label', { collapsed: el.collapsed })}>
                  {el.label}
                </div>
              </a>
            </li>
          ))}
      </Fragment>
    );
  }
}

AppSidebarItem.propTypes = {
  location: PropTypes.object,
  to: PropTypes.string,
  active: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  history: PropTypes.object.isRequired,
};

AppSidebarItem.defaultProps = {
  badge: null,
};

export default withRouter(AppSidebarItem);
